/* LMC product-card image gallery.

   The product card (snippets/lmc-product-card.liquid) stacks every product
   image as a slide inside the image link; the prev/next carets cycle which
   one carries `.is-active`. A single delegated listener handles it so cards
   injected after load (quick view, recommendations) work without rebinding.
   Loaded globally from layout/theme.liquid because cards appear site-wide. */
(function () {
  function step(wrap, dir) {
    var slides = wrap.querySelectorAll('.lmc-pcard__img');
    if (slides.length < 2) return;
    var current = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) {
        current = i;
        break;
      }
    }
    var next = (current + dir + slides.length) % slides.length;
    slides[current].classList.remove('is-active');
    slides[next].classList.add('is-active');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pcard-prev], [data-pcard-next]');
    if (!btn) return;
    var wrap = btn.closest('.lmc-pcard__imgwrap');
    if (!wrap) return;
    event.preventDefault();
    step(wrap, btn.hasAttribute('data-pcard-next') ? 1 : -1);
  });
})();
